import { capEditSecondaryApi, execute } from '@/utils/api';
import type {
  EntityAdministrationalSecondaryMember,
  EntityAdministrationalSecondaryOrganization,
  EntitySuccessMsg
} from '@/utils/api/maintenance/api';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { de } from 'vuetify/locale';

export const useSecondaryStore = defineStore(
  'secondary',
  () => {
    /** 二次専門組織 - 検索条件（サービス） */
    const serviceId = ref<number | undefined>(undefined);

    /* 二次専門組織 - 検索条件（組織名称） */
    const organizationName = ref<string | undefined>(undefined);

    /** 二次専門組織 - リスト */
    const organizations = ref<EntityAdministrationalSecondaryOrganization[]>([]);

    /** 二次専門組織 - 総件数 */
    const organizationTotal = ref<number>(0);

    /**二次専門組織 - 検索条件（住所） */
    const address = ref<string | undefined>(undefined);

    /** 二次専門組織 - ページネーション */
    const itemsPerPage = ref<number>(25);
    const page = ref<number>(1);

    /** 二次専門組織リストを取得する */
    const fetchOrganizations = (
      pageMax: number,
      pageNum: number,
      serviceId?: number,
      name?: string,
      address?: string
    ): Promise<any> => {
      return execute(
        () =>
          capEditSecondaryApi.getSecondaryOrganizations(
            pageMax,
            pageNum,
            name?.length ? name : undefined,
            serviceId,
            address?.length ? address : undefined
          ),
        true
      )
        .then((data: { total: number; items: EntityAdministrationalSecondaryOrganization[] }) => {
          console.info(' ２次専門組織 一覧取得成功');

          // 二次専門組織リストを更新
          organizations.value = data.items;
          // 総件数を更新
          organizationTotal.value = data.total;
        })
        .catch((e: unknown) => {
          console.warn('二次専門組織 一覧取得失敗');
          organizations.value = [];
          organizationTotal.value = 0;
        });
      // .finally(()=>{
      //   //  TODO mock
      //   organizations.value = [{
      //     "organizationId": 1,
      //     "serviceIds": [
      //       1,2
      //     ],
      //     "name": "AFC",
      //     "type": "secondary",
      //     "tel": "string",
      //     "address": "string",
      //     "memberNum": 99,
      //     "createdAt": "2024-12-05T02:29:09.720Z",
      //     "updatedAt": "2024-12-05T02:29:09.720Z",
      //     "updatedById": 1,
      //     "updatedByName": "管理 太郎"
      //   }]
      //   organizationTotal.value = 1;
      //   SDstore.value={
      //     "organizationId": 1,
      //     "serviceIds": [
      //       1,2
      //     ],
      //     "name": "AFC",
      //     "type": "secondary",
      //     "tel": "string",
      //     "address": "string",
      //     "memberNum": 99,
      //     "createdAt": "2024-12-05T02:29:09.720Z",
      //     "updatedAt": "2024-12-05T02:29:09.720Z",
      //     "updatedById": 1,
      //     "updatedByName": "管理 太郎"
      //   }
      // });
    };

    /** 二次専門組織を更新する */
    const updateOrganization = (
      id: number,
      organization: EntityAdministrationalSecondaryOrganization
    ): Promise<void> => {
      return new Promise((resolve, reject) => {
        execute(() => capEditSecondaryApi.updateSecondaryOrganization(id, organization), true)
          .then((data: EntityAdministrationalSecondaryOrganization) => {
            console.info('二次専門組織 更新成功');
            // リストを更新する
            const index = organizations.value.findIndex((v) => v.organizationId === id);
            if (index != -1) {
              organizations.value[index] = data;
            }
            resolve();

            SDstore.value = data;
          })
          .catch((e: unknown) => {
            console.warn('二次専門組織 更新失敗');
            reject();
          });
        // mock処理
        //         .finally(()=>{
        //           console.info('二次専門組織 更新成功');
        //           // リストを更新する
        //           const index = organizations.value.findIndex((v) => v.organizationId === id);
        //           if (index != -1) {
        //             organizations.value[index]  = {
        //               "organizationId": 1,
        //               "serviceIds": [
        //                 1
        //               ],
        //               "name": "AFC",
        // "tel": "string",
        // "address": "string",
        // "createdAt": "2024-12-16T07:51:26.862Z",
        // "updatedAt": "2024-12-16T07:51:26.862Z",
        // "updatedById": 1,
        // "updatedByName": "管理 太郎"
        //             }
        //             SDstore.value={
        //               "organizationId": 1,
        //               "serviceIds": [
        //                 1
        //               ],
        //               "name": "AFCccccc",
        // "tel": "string",
        // "address": "string",
        // "createdAt": "2024-12-16T07:51:26.862Z",
        // "updatedAt": "2024-12-16T07:51:26.862Z",
        // "updatedById": 1,
        // "updatedByName": "管理 太郎"
        //             };
        //           }
        //           resolve();
        //         })
      });
    };

    /** 二次専門組織を削除する  */
    const deleteOrganization = (id: number): Promise<void> => {
      return new Promise((resolve, reject) => {
        execute(() => capEditSecondaryApi.deleteSecondaryOrganization(id), true)
          .then((data: EntitySuccessMsg[]) => {
            console.info('二次専門組織 削除成功');
            // リストから削除する
            const index = organizations.value.findIndex((v) => v.organizationId === id);
            if (index != -1) {
              organizations.value.splice(index, 1);
            }
            resolve();
          })
          .catch((e: unknown) => {
            console.warn('二次専門組織 削除失敗');
            reject();
          });
        // .finally(() => {
        //   console.info('二次専門組織 削除成功');
        //   // リストから削除する
        //   const index = organizations.value.findIndex((v) => v.organizationId === id);
        //   if (index != -1) {
        //     organizations.value.splice(index, 1);
        //   }
        //   resolve();
        // });
      });
    };

    /**
     * IDから二次専門組織を取得する
     * @param id
     * @returns EntityAdministrationalSecondaryOrganization 二次専門組織
     */
    const getOrganizationById = (
      id: number
    ): EntityAdministrationalSecondaryOrganization | undefined => {
      return organizations.value.find((v) => v.organizationId === id);
    };

    // 二次専門組織 _ 新規登録 _ 詳細画面格納
    const SDstore = ref<EntityAdministrationalSecondaryOrganization | undefined>(undefined);
    console.log(SDstore);

    // 二次専門組ユーザー _ 新規登録 _ ユーザー部格納
    const SUstore = ref<EntityAdministrationalSecondaryMember | undefined>(undefined);

    /** 二次専門組織ユーザ - 検索条件（ユーザー名） */
    const memberId = ref<string | undefined>('');

    /* 二次専門組織ユーザ - 検索条件（E-mail） */
    const Email = ref<string | undefined>(undefined);

    /** 二次専門組織ユーザー - リスト */
    const members = ref<EntityAdministrationalSecondaryMember[]>([]);

    /** 二次専門組織ユーザー - 総件数 */
    const memberTotal = ref<number>(0);

    // 新規登録 - 編集 - ユーザ名の表記処理
    const username = ref<boolean>(false);

    // パスワード変更
    const passchange = ref<boolean>(false);

    /** 二次専門組織ユーザの一覧を取得する */
    const fetchMembers = (
      organizationId: number,
      pageMax: number,
      pageNum: number,
      name_user?: string,
      email?: string
    ): Promise<any> => {
      return execute(
        () =>
          capEditSecondaryApi.getSecondaryOrganizationMembers(
            organizationId,
            pageMax,
            pageNum,
            name_user?.length ? name_user : undefined,
            email?.length ? email : undefined
          ),
        true
      )
        .then((data: { total: number; items: EntityAdministrationalSecondaryMember[] }) => {
          console.info(' ユーザー 一覧取得成功');
          console.log(data);

          // ユーザーリストを更新
          members.value = data.items;
          // 総件数を更新
          memberTotal.value = data.total;
        })
        .catch((e: unknown) => {
          console.warn('ユーザー 一覧取得失敗');
          members.value = [];
          memberTotal.value = 0;
        });
      //     .finally(()=>{
      //       //  TODO mock
      //       console.info(' ユーザー 一覧取得成功');
      //       members.value = [{
      //         "memberId": 1,
      // "name": "二次 次郎",
      // "email1": "test@example.com",
      // "email2": "test@exampleeee.com",
      // "sub": "string",
      // "tel1": "string",
      // "tel2": "string",
      // "tel3": "string",
      // "sms": "string",
      // "comment": "string",
      // "num_locations": 10,
      // "createdAt": "2024-12-17T05:40:07.383Z",
      // "updatedAt": "2024-12-17T05:40:07.383Z",
      // "updatedById": 1,
      // "updatedByName": "管理 太郎"
      //       }]
      //       memberTotal.value = 1;
      //       SUstore.value={
      //         "memberId": 1,
      // "name": "二次 次郎",
      // "email1": "test@example.com",
      // "email2": "test@exampleeee.com",
      // "sub": "string",
      // "tel1": "string",
      // "tel2": "string",
      // "tel3": "string",
      // "sms": "string",
      // "comment": "string",
      // "num_locations": 10,
      // "createdAt": "2024-12-17T05:40:07.383Z",
      // "updatedAt": "2024-12-17T05:40:07.383Z",
      // "updatedById": 1,
      // "updatedByName": "管理 太郎"
      //       }
      //     });
    };

    // 二次専門組織ユーザを更新する
    const updateMember = (
      organizationId: number,
      MemberId: number,
      member: EntityAdministrationalSecondaryMember
    ): Promise<void> => {
      return new Promise((resolve, reject) => {
        execute(
          () =>
            capEditSecondaryApi.updateSecondaryOrganizationMember(organizationId, MemberId, member),
          true
        )
          .then((data: EntityAdministrationalSecondaryMember) => {
            console.info('二次専門組織ユーザ 更新成功');
            // リストを更新する
            const index = members.value.findIndex((v) => v.memberId === MemberId);
            if (index != -1) {
              members.value[index] = data;
            }
            resolve();

            SUstore.value = data;
          })
          .catch((e: unknown) => {
            console.warn('二次専門組織ユーザ 更新失敗');
            reject();
          });
        // mock処理
        // .finally(()=>{
        //   console.info('二次専門組織ユーザ 更新成功');
        //   // リストを更新する
        //   const index = members.value.findIndex((v) => v.memberId === MemberId);
        //   if (index != -1) {
        //     members.value[index]  = {
        //       "memberId": 1,
        //       "name": "二次 次郎",
        //       "email1": "test@example.com",
        //       "email2": "test@example.com",
        //       "sub": "string",
        //       "tel1": "string",
        //       "tel2": "string",
        //       "tel3": "string",
        //       "sms": "string",
        //       "comment": "string",
        //       "num_locations": 10,
        //       "createdAt": "2024-12-17T05:39:20.556Z",
        //       "updatedAt": "2024-12-17T05:39:20.556Z",
        //       "updatedById": 1,
        //       "updatedByName": "管理 太郎"
        //     }
        //     SUstore.value={
        //       "memberId": 1,
        //       "name": "二次 次郎",
        //       "email1": "test@example.com",
        //       "email2": "test@exampleeee.com",
        //       "sub": "string",
        //       "tel1": "string",
        //       "tel2": "string",
        //       "tel3": "string",
        //       "sms": "string",
        //       "comment": "string",
        //       "num_locations": 10,
        //       "createdAt": "2024-12-17T05:39:20.556Z",
        //       "updatedAt": "2024-12-17T05:39:20.556Z",
        //       "updatedById": 1,
        //       "updatedByName": "管理 太郎"
        //     };
        //     resolve();
        //   }
        // })
      });
    };

    /** 二次専門組織ユーザを削除する  */
    const deleteSecondaryOrganizationMember = (
      organizationId: number,
      MemberId: number
    ): Promise<void> => {
      return new Promise((resolve, reject) => {
        execute(
          () => capEditSecondaryApi.deleteSecondaryOrganizationMember(organizationId, MemberId),
          true
        )
          .then((data: EntitySuccessMsg[]) => {
            console.info('二次専門組織ユーザ 削除成功');
            // リストから削除する
            const index = members.value.findIndex((v) => v.memberId === MemberId);
            if (index != -1) {
              members.value.splice(index, 1);
            }
            resolve();
          })
          .catch((e: unknown) => {
            console.warn('二次専門組織ユーザ 削除失敗');
            reject();
          });
        // .finally(() => {
        //   console.info('二次専門組織ユーザ 削除成功');
        //   // リストから削除する
        //   const index = members.value.findIndex((v) => v.memberId === MemberId);
        //   if (index != -1) {
        //     members.value.splice(index, 1);
        //   }
        //   resolve();
        // });
      });
    };

    /**
     * IDから二次専門組織ユーザーを取得する
     * @param id
     * @returns EntityAdministrationalSecondaryMember 二次専門組織ユーザー
     */
    const getMemberById = (id: number): EntityAdministrationalSecondaryMember | undefined => {
      return members.value.find((v) => v.memberId === id);
    };

    /**
     * storeの初期化
     */
    const clear = (): void => {
      serviceId.value = undefined;
      organizationName.value = undefined;
      organizations.value = [];
      organizationTotal.value = 0;
      address.value = undefined;
      itemsPerPage.value = 25;
      page.value = 0;

      memberId.value = undefined;
      Email.value = undefined;
      members.value = [];
      memberTotal.value = 0;
      SDstore.value = undefined;
      SUstore.value = undefined;
      username.value = false;
      passchange.value = false;
    };

    return {
      serviceId,
      organizationName,
      organizations,
      organizationTotal,
      address,
      itemsPerPage,
      page,
      fetchOrganizations,
      getOrganizationById,
      updateOrganization,
      deleteOrganization,
      memberId,
      Email,
      members,
      memberTotal,
      fetchMembers,
      SDstore,
      SUstore,
      updateMember,
      deleteSecondaryOrganizationMember,
      getMemberById,
      username,
      passchange,
      clear
    };
  },
  { persist: { storage: sessionStorage } }
);
